<template>
<!-- 个人中心页面 -->
  <div>
    <div class="commonFilter">
      <div class="card-container">
        <div class="card-content">
          <!-- 公司信息 -->
          <h2 style="position:relative;right:11px;padding-top:10px;">{{$t('logisticsProvider.companyInfo')}}
            &nbsp;&nbsp;
            <span style="font-size:15px;background-color:#FAAD14;color:#FFFFFF;width:120px;border-radius:5px;padding:2px;padding-left:5px;padding-right:5px;" v-if="companyInfo.status == '0'">未审核</span>
            <span style="font-size:15px;background-color:#FAAD14;color:#FFFFFF;width:120px;border-radius:5px;padding:2px;padding-left:5px;padding-right:5px;" v-if="companyInfo.status == '1'">审核中</span>
            <span style="font-size:15px;background-color:#D0E17D;color:#FFFFFF;width:120px;border-radius:5px;padding:2px;padding-left:5px;padding-right:5px;" v-if="companyInfo.status == '2'">审核通过</span>
            <span style="font-size:15px;background-color:#FF6633;color:#FFFFFF;width:120px;border-radius:5px;padding:2px;padding-left:5px;padding-right:5px;" v-if="companyInfo.status == '3'">审核失败</span>
            <span style="font-size:15px;color:#ed3f14;width:120px;padding:2px;padding-left:5px;padding-right:5px;" v-if="companyInfo.status == '0'">（请填写好资料提交审核）</span>
          </h2>
            <Row>
                <Col span="4">
                  <!-- 占位图 -->
                  <div class="picBox" v-if="pageParams.partnerLogo === null || pageParams.partnerLogo === ''">
                    <Icon style="marginTop:50px;marginLeft:85px" type="image" size="50" color="#d4d4d4"></Icon>
                    <p style="color:#cccccc;marginTop:10px;marginLeft:85px">{{$t('common.nocompanyImg')}}</p>
                  </div>
                  <!-- 显示图片 -->
                  <div class="picBox" v-else>
                    <img style="width:100%;height:100%;" :src="pageParams.partnerLogo">
                  </div>
                  <!-- 编辑 -->
                  <div class="urlBtn">
                    <Upload
                      ref="uploadLogo"
                      name="file"
                      :headers="uploadFilesHeader"
                      :max-size="uploadFilesMaxSize"
                      :on-exceeded-size="uploadMaxSize"
                      :show-upload-list="false"
                      :format="['jpg', 'png', 'gif', 'bmp', 'jpeg']"
                      :on-success="uploadFilesSuccess"
                      :on-error="uploadFilesError"
                      :on-format-error="handleFormatError"
                      :action="uploadFilesUrl">
                      <Button v-if="!isEditStatus" style="margin-left:90px;;margin-top:10px;" icon="edit" type="ghost">{{ $t('common.edit') }}</Button>
                    </Upload>
                  </div>
                </Col>
                <Col span="18">
                  <div v-show="isEditStatus">
                    <Form label-position="right" :label-width="160">
                      <Row>
                        <!-- 用户编号 -->
                        <Col span="8">
                          <Form-item :label="$t('common.partnerId') + '：'">
                            <span>{{companyInfo.partnerId}}</span>
                          </Form-item>
                        </Col>
                        <!-- 公司名称 -->
                        <Col span="8">
                          <Form-item :label="$t('common.companyName') + '：'">
                            <span>{{companyInfo.partnerName}}</span>
                          </Form-item>
                        </Col>
                      </Row>
                      <Row>
                        <!-- 公司地址 -->
                        <Col span="8">
                          <Form-item :label="$t('common.companyAds') + '：'">
                            <span>{{companyInfo.partnerAddress}}</span>
                          </Form-item>
                        </Col>
                        <!-- 邮箱 -->
                        <Col span="8">
                          <Form-item :label="$t('common.email') + '：'">
                            <span>{{companyInfo.partnerEmail}}</span>
                          </Form-item>
                        </Col>
                      </Row>
                      <Row>
                        <!-- 联系人 -->
                        <Col span="8">
                          <Form-item :label="$t('common.contactName') + '：'">
                            <span>{{companyInfo.partnerLinkman}}</span>
                          </Form-item>
                        </Col>
                        <!-- 手机号 -->
                        <Col span="8">
                          <Form-item :label="$t('common.mobile') + '：'">
                            <span>{{companyInfo.partnerBusiM}}</span>
                          </Form-item>
                        </Col>
                      </Row>
                      <Row>
                        <!-- 营业执照 -->
                        <Col span="8">
                          <Form-item :label="$t('common.businessLicense') + '：'">
                            <a :href="companyInfo.businessLicenseUrl" target="_blank">{{companyInfo.showBusinessLicenseUrl}}</a>
                          </Form-item>
                        </Col>
                        <Col span="8">
                          <Form-item :label="$t('common.displayCarrierName') + '：'">
                            <span>{{companyInfo.partnerShortName}}</span>
                          </Form-item>
                        </Col>
                      </Row>
                      <Row>
                        <!-- 营业执照 -->
                        <Col span="8">

                        </Col>
                        <Col span="8">
                          <Form-item :label="$t('common.companyAttr') + '：'">
                            <span v-if="companyInfo.partnerType == '0'">{{ $t('common.thirdLogis') }}</span>
                            <span v-if="companyInfo.partnerType == '1'">{{ $t('common.overseasWarehouse') }}</span>
                            <a :href="appUrl" target="_blank" v-if="companyInfo.status == '2'">{{ $t('common.appmanage') }}</a>
                          </Form-item>
                        </Col>
                      </Row>
                      <div class="explain" style="padding-left: 20px;" v-if="dyParams.length > 0">
                        <div class="cutline"></div>
                          <h2>物流API参数</h2><span style="color:red">(用于卖家在通途物流设置界面填写的，是便于物流商系统区分订单来源(客户)，一旦提交审核了就不可以修改,不填写默认key是token)</span>
                          <div class="paramsCont" v-for="(item, index) in dyParams" :key="index">
                              <Row>
                                  <!-- 参数名称 -->
                                  <Col span="8">
                                      <Form-item :label="'通途显示'+$t('common.parameterName') + '：'" >
                                          <span>{{dyParams[index].parameterName}}</span>
                                      </Form-item>
                                  </Col>
                                  <!-- 参数key -->
                                  <Col span="8">
                                      <Form-item :label="$t('common.parameterKey') + '：'" >
                                          <span>{{dyParams[index].parameterKey}}</span>
                                      </Form-item>
                                  </Col>
                              </Row>
                          </div>
                        </div>
                    </Form>
                  </div>
                  <div v-show="!isEditStatus">
                      <Form ref="pageParams" :model="pageParams" label-position="right" :label-width="160" :rules="ruleValidate">
                        <Row>
                          <!-- 用户编号 -->
                          <Col span="8">
                            <Form-item :label="$t('common.partnerId') + '：'">
                              <span>{{companyInfo.partnerId}}</span>
                            </Form-item>
                          </Col>
                          <!-- 公司名称 -->
                          <Col span="8">
                            <Form-item :label="$t('common.companyName') + '：'" prop='partnerName'>
                              <Input v-model.trim="pageParams.partnerName"></Input>
                            </Form-item>
                          </Col>
                        </Row>
                        <Row>
                          <!-- 公司地址 -->
                          <Col span="8">
                            <Form-item :label="$t('common.companyAds') + '：'" prop='partnerAddress'>
                              <Input v-model.trim="pageParams.partnerAddress"></Input>
                            </Form-item>
                          </Col>
                          <!-- 邮箱 -->
                          <Col span="8">
                            <Form-item :label="$t('common.email') + '：'" prop='partnerEmail'>
                              <Input v-model.trim="pageParams.partnerEmail"></Input>
                            </Form-item>
                          </Col>
                        </Row>
                        <Row>
                          <!-- 联系人 -->
                          <Col span="8">
                            <Form-item :label="$t('common.contactName') + '：'" prop='partnerLinkman'>
                              <Input v-model.trim="pageParams.partnerLinkman"></Input>
                            </Form-item>
                          </Col>
                          <!-- 手机号 -->
                          <Col span="8">
                            <Form-item :label="$t('common.mobile') + '：'" prop='partnerBusiM'>
                              <Input v-model.trim="pageParams.partnerBusiM"></Input>
                            </Form-item>
                          </Col>
                        </Row>
                        <Row>
                          <!-- 营业执照 -->
                          <Col span="8">
                            <Form-item :label="$t('common.businessLicense') + '：'" prop='businessLicenseUrl'>
                              <Upload
                                ref="uploadLicense"
                                name="file"
                                :headers="uploadFilesHeader"
                                :max-size="uploadFilesMaxSize"
                                :on-exceeded-size="uploadMaxSize"
                                :show-upload-list="false"
                                :format="['pdf']"
                                :on-success="uploadLicenseSuccess"
                                :on-error="uploadFilesError"
                                :on-format-error="handlePdfFormatError"
                                :action="uploadFilesUrl">
                                <Button v-if="!isEditStatus" style="margin-left:10px;vertical-align: middle;" icon="file" type="ghost">{{ $t('common.selectFile') }}</Button>
                                <span style="vertical-align: middle;">{{ $t('common.supportPdf') }}</span>
                                <span style="vertical-align: middle;">{{uploadLicenseUrl}}</span>
                              </Upload>
                            </Form-item>
                          </Col>
                          <Col span="8">
                            <Form-item :label="$t('common.displayCarrierName') + '：'" >
                              <Input v-model.trim="pageParams.partnerShortName"></Input>
                            </Form-item>
                            <span style="color:red">(如果没填写默认用公司名称,只在审核前填写ERP才有效，审核后只在物流平台生效。)</span>
                          </Col>
                        </Row>
                        <div v-if="companyInfo.status == '0' || companyInfo.status == '3'">
                          <div class="cutline"></div>
                          <h2>物流API参数<br><span style="color:red">(用于卖家在通途物流设置界面填写的，是便于物流商系统区分订单来源(客户)，一旦提交审核了就不可以修改,不填写默认key是token,请慎重填写！！)</span></h2>
                          <div class="explain" style="padding-left: 20px;height: 70px;padding-top: 20px;">
                              <Row>
                                <Col span="7">
                                  <Form-item :label="$t('common.carrierSystem') + '：'">
                                    <Select v-model="pageParams.carrierSystem" filterable :placeholder="$t('common.carrierSystem')" :disabled="paramDisabled" style="width:100px;" @on-change="changeCarrierSystem">
                                        <Option v-for="item in carrierSystemList" :value="item.source" :key="item.source">{{item.name}}</Option>
                                    </Select>
                                  </Form-item>
                                </Col>
                                <Col span="11" style="padding-left:10px;">
                                  <span style="font-size:15px;text-align:right;">(非自研系统的物流商可选,选择后自动填充下面参数，其它默认选择自研系统)</span>
                                </Col>
                              </Row>
                          </div>
                          <div class="explain" style="padding-left: 20px;" v-if="dyParams.length > 0">
                            <div class="paramsCont" v-for="(item, index) in dyParams" :key="index">
                                <Row>
                                    <!-- 参数名称 -->
                                    <Col span="8">
                                        <Form-item :label="'通途显示'+$t('common.parameterName') + '：'" >
                                            <Input v-model.trim="dyParams[index].parameterName" :disabled="paramDisabled"></Input>
                                        </Form-item>
                                    </Col>
                                    <!-- 参数key -->
                                    <Col span="8">
                                        <Form-item :label="$t('common.parameterKey') + '：'" >
                                            <Input v-model.trim="dyParams[index].parameterKey" :disabled="paramDisabled"></Input>
                                        </Form-item>
                                    </Col>
                                    <Col span="2">
                                        <Button v-if="index == (dyParams.length-1) && !paramDisabled" type="primary" style="margin-left:10px;" @click="addParam" >+</Button>
                                        <Button v-if="dyParams.length > 1 && !paramDisabled" style="margin-left:10px;" @click="removeParam(index)" >-</Button>
                                    </Col>
                                </Row>
                            </div>
                          </div>
                          <Row v-if="dyParams.length == 0">
                            <Col span="16">

                            </Col>
                            <Col span="2">
                                <Button type="primary" style="margin-left:10px;" @click="addParam" >+</Button>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                  </div>
                  <Row>
                    <Col>
                      <div style="float:right;">
                        <Button v-if="isEditStatus" type="primary" icon="edit" @click="editData">{{$t('logisticsProvider.editData')}}</Button>
                        <div v-if="!isEditStatus">
                          <Button v-if="!(companyInfo.status == '0' || companyInfo.status == '3')" type="primary" icon="checkmark-round" @click="saveData('pageParams')">{{$t('common.save')}}</Button>
                          <Button v-if="companyInfo.status == '0' || companyInfo.status == '3'" type="primary" icon="checkmark-round" @click="saveData('pageParams')">{{$t('common.saveAndApproval')}}</Button>
                          <Button style="marginLeft:10px;" icon="close-round" @click="cancel">{{$t('common.cancel')}}</Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
              </Col>
          </Row>
          <div style="width:80%;border:1px solid #FAAD14;height:30px;padding-top:3px;margin-top:10px;" v-if="companyInfo.status == '3'">
            <img src="../../../../theme/ocean/images/u31.png" style="padding-left:10px;"/>
             <span style="text-align:center;">{{companyInfo.checkRemark}}!</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 昨日包裹量 -->
    <!-- <div class="packageNum">
      <h2>{{$t('common.yesterdayPm') + '：' + packageQuantity + '，' + $t('logisticsProvider.overPackage1') + ratio + '%' + $t('logisticsProvider.overPackage2')}}</h2>
    </div> -->
    <!-- 包裹数量 -->
    <!-- <div class="packNum">
      <h2 style="paddingTop:15px;marginLeft:10px;">{{$t('common.packNum')}}</h2>
      <div id="myChart" :style="{width: '1500px', height: '300px'}"></div>
    </div> -->
    <!-- 产品服务 -->
    <!--
    <div class="orderTable normalTop">
      <h2>{{$t('common.productServer')}}</h2>
      <Table highlight-row border :columns="productServerColumns" :data="productServerData"></Table>
    </div>
    -->
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  data () {
    let self = this;
    const validateBusinessLicenseUrl = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(self.t('validValue.nobusinessLicense')));
      } else {
        callback();
      }
    };
    return {
      pageParams: {
        partnerName: '', // 公司名称
        partnerShortName: '', // 公司简称，作为ERP显示的物流商名称
        partnerDesc: '', // 公司地址
        partnerEmail: '', // 邮箱
        partnerLinkman: '', // 联系人
        partnerBusiM: '', // 手机号
        partnerLogo: '', // 图片
        businessLicenseUrl: '', // 营业执照
        carrierSystem: ''// 物流系统,默认自研系统
      },
      // 校验
      ruleValidate: {
        partnerName: [
          { required: true, message: self.t('validValue.noCompanyName'), trigger: 'blur' }
        ],
        partnerAddress: [
          { required: true, message: self.t('validValue.noCompanyAddress'), trigger: 'blur' }
        ],
        partnerEmail: [
          { required: true, message: self.t('validValue.noEmail'), trigger: 'blur' },
          { type: 'email', message: self.t('validValue.emailError'), trigger: 'blur' } // 邮箱
        ],
        partnerLinkman: [
          { required: true, message: self.t('validValue.noLinkMan'), trigger: 'blur' }
        ],
        partnerBusiM: [
          { required: true, message: self.t('validValue.noCellphone'), trigger: 'blur' },
          { validator: self.validateMobile(), trigger: 'blur' } // 手机号码
        ],
        businessLicenseUrl: [
          { required: true, validator: validateBusinessLicenseUrl, trigger: 'change' }
        ]
      },
      dyParams: [],
      selectedParams: [],
      paramDisabled: false,
      companyInfo: {}, // 公司信息
      uploadFilesUrl: api.uploadImg, // 上传url
      uploadLicenseUrl: '',
      uploadFilesHeader: { // 上传logo协议头
        Authorization: sessionStorage.getItem('token')
      },
      appUrl: 'https://open.tongtool.com/openApi.html#/applicationList',
      uploadFilesMaxSize: 2048, // 上传文件大小上线（kb）
      isEditStatus: true, // 控制编辑状态
      packageQuantity: 0, // 昨天包裹数量
      ratio: 0, // 昨天使用占比
      monthDate: [], // 近30天日期
      monthPackageNum: [], // 近30天包裹数量
      productServerColumns: [
        {
          title: self.t('common.productName'),
          key: 'productName',
          align: 'center'
        },
        {
          title: self.t('common.productDes'),
          key: 'productDes',
          align: 'center'
        },
        {
          title: self.t('common.orderPrice'),
          key: 'orderPrice',
          align: 'center'
        },
        {
          title: self.t('common.productStatus'),
          key: 'productStatus',
          align: 'center'
        },
        {
          title: self.t('common.operation'),
          align: 'center',
          render: (h, params) => {

          }
        }
      ],
      productServerData: [],
      carrierSystemList: []
    };
  },
  methods: {
    // 手机校验，可共用
    validateMobile () {
      let v = this;
      var isMob = /^((\+?86)|(\(\+86\)))?(13[0-9]{9}|15[0-9]{9}|18[0-9]{9}|14[0-9]{9}|16[0-9]{9}|17[0-9]{9}|19[0-9]{9}|(5|6|8|9)\d{7})$/;
      var validateMobile = function (rule, value, callback) {
        if (!isMob.test(value) && value !== '') {
          callback(new Error(v.t('validValue.phoneError')));
        } else {
          callback();
        }
      };
      return validateMobile;
    },
    // 公司基本信息
    getLogisInfo () {
      let v = this;
      v.axios.post(api.get_memberInfo)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data !== null) {
              if (data.businessLicenseUrl) {
                var index = data.businessLicenseUrl.lastIndexOf('/') + 1;
                data.showBusinessLicenseUrl = data.businessLicenseUrl.substr(index);
              }
              v.companyInfo = data;
              v.pageParams.partnerLogo = data.partnerLogo;
              v.getParams();
              if (v.companyInfo.systemCarrier && v.companyInfo.systemCarrier.systemCarrierId && v.companyInfo.systemCarrier.systemCarrierId !== '') {
                v.paramDisabled = true;
              }
              if (v.companyInfo.status === '0' || v.companyInfo.status === '3') {
                v.getCarrierSystem();
              }
            } else {
              v.companyInfo = {};
              v.pageParams.partnerLogo = '';
            }
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    },
    getCarrierSystem () {
      let v = this;
      v.axios.get(api.platform_param)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            // 设置默认系统
            let _params = [];
            if (v.selectedParams) {
              v.selectedParams.forEach((p, i) => {
                _params.push({
                  name: p.parameterName,
                  key: p.parameterKey
                });
              });
            }
            if (_params.length === 0) {
              _params.push({
                name: 'Token',
                key: 'token'
              });
            }

            let defaultParam = {
              source: 'own',
              name: '自研系统',
              params: _params
            };
            v.carrierSystemList.push(defaultParam);
            v.pageParams.carrierSystem = 'own';
            if (data) {
              data.forEach((item, i) => {
                v.carrierSystemList.push(item);
              });
            } else {
              v.carrierSystemList = [];
            }
          }
        });
    },
    changeCarrierSystem () {
      let v = this;
      v.dyParams = [];
      let systemParams = [];
      v.carrierSystemList.forEach((item, i) => {
        if (item.source === v.pageParams.carrierSystem) {
          systemParams = item.params;
          if (item.source !== 'own') {
            v.paramDisabled = true;
          } else {
            v.paramDisabled = false;
          }
        }
      });
      systemParams.forEach((p, i) => {
        v.dyParams.push({
          parameterName: p.name,
          parameterType: '03', // 参数类型：01/Radio;02/Checkbox;03/input;04/Selection;05/Object;06/ReadOnly
          parameterKey: p.key
        });
      });
    },
    // 获取昨天包裹数量和占比
    getYesterdayInfo () {
      let v = this;
      v.axios.post(api.get_yesterdayInfo)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            v.packageQuantity = data.packageQuantity === null ? 0 : data.packageQuantity; // 包裹数量
            v.ratio = data.ratio === null ? 0 : data.ratio; // 使用占比
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
      // debugger;
    },
    // 控制上传图片大小
    uploadMaxSize (file) {
      // this.$Message.error(this.t('logisticsProvider.exceedSize'));
      let v = this;
      v.$Notice.warning({
        title: v.t('common.fileSizeLimit'),
        desc: v.t('common.file') + file.name + v.t('common.moreSize')
      });
      // debugger;
    },
    // 上传成功
    uploadFilesSuccess (res, file, uploadFiles) {
      // this.pageParams.partnerLogo = file.response.datas;
      // debugger;
      let v = this;
      if (res.code === 0) {
        v.pageParams.partnerLogo = res.datas; // 返回图片链接
      } else {
        v.showErrorInfoFn(res.code, res.message); // 错误提示方法
      }
    },
    uploadLicenseSuccess (res, file, uploadFiles) {
      // this.pageParams.partnerLogo = file.response.datas;
      // debugger;
      let v = this;
      if (res.code === 0) {
        v.pageParams.businessLicenseUrl = res.datas;
        var index = res.datas.lastIndexOf('/') + 1;
        v.uploadLicenseUrl = res.datas.substr(index); // 返回图片链接
      } else {
        v.showErrorInfoFn(res.code, res.message); // 错误提示方法
      }
    },
    // 上传文件异常
    uploadFilesError () {
      this.$Message.error(this.t('common.sysErrorMes'));
    },
    // 上传文件格式异常
    handleFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('validValue.fileError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'jpg,png,gif,bmp,jpeg'
      });
    },
    handlePdfFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('validValue.fileError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'pdf'
      });
    },
    // 修改资料
    editData () {
      let v = this;
      v.isEditStatus = !v.isEditStatus;
      v.pageParams = v.companyInfo;
      if (v.companyInfo.status === '0' || v.companyInfo.status === '3') {
        v.pageParams.carrierSystem = 'own';
      }
    },
    // 保存修改后的公司信息
    saveData (name) {
      let v = this;
      v.$refs[name].validate((valid) => {
        if (valid) {
          if (!v.pageParams.businessLicenseUrl || v.pageParams.businessLicenseUrl === '') {
            v.$Message.error(v.t('validValue.nobusinessLicense'));
            return;
          }
          if (!v.companyInfo.partnerId || v.companyInfo.partnerId === '') {
            v.$Message.error({
              content: "当前登陆账号非物流平台注册账号，请登出！<br/><div style='text-align:left;margin-left:10px;'>1.如果已注册物流平台，请使用物流平台账号登陆；<br/>2.如果未注册物流平台账号，请使用正确注册地址：https://logismg.tongtool.com/index.html#/register 进行注册；<br/>3.不要在同一个浏览器登陆多个通途业务的账号。</div>",
              duration: 5
            });
            return;
          }
          if (v.companyInfo.status === '0' || v.companyInfo.status === '3') {
            if (v.dyParams.length === 0) {
              v.$Message.error('请添加参数');
              return;
            }
            var flag = false;
            v.dyParams.forEach((n, i) => {
              if (n.parameterName === '') {
                v.$Message.error('参数名不能为空');
                flag = true;
                return;
              }
              if (n.parameterKey === '') {
                v.$Message.error('参数Key不能为空');
                flag = true;
              }
            });
            if (flag) {
              return;
            }
            v.pageParams.status = '1';// 变更为待审核状态
            v.pageParams.defineParameterList = v.dyParams;
          }
          v.axios.post(api.edit_memberInfo, v.pageParams)
            .then(res => {
              if (res.data.code === 0) {
                v.$Message.success(v.t('common.saveSuccess'));
                v.isEditStatus = !v.isEditStatus;
                this.getLogisInfo();
              } else {
                v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
              }
            });
        } else {
          v.$Message.info({
            content: v.t('error.saveError'),
            duration: 3
          });
        }
      });
    },
    // 取消修改公司信息
    cancel () {
      let v = this;
      v.isEditStatus = !v.isEditStatus;
    },
    // 折线图
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let v = this;
      let date = [];
      let packageNum = [];
      v.axios.post(api.get_monthInfo)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas; // 获取近30天的包裹数量
            for (let i in data) {
              date.push(i);
              packageNum.push(data[i]);
            }
            v.monthDate = date; // x 轴数据
            v.monthPackageNum = packageNum; // y 轴数据
            // let myChart = v.$echarts.init(document.getElementById('myChart'));
            console.log(v.monthDate);
            // 绘制图表
            // myChart.setOption({
            //   tooltip: {
            //     trigger: 'axis'
            //   },
            //   xAxis: { // 横轴
            //     type: 'category',
            //     name: v.t('common.dates'),
            //     axisTick: {
            //       alignWithLabel: true
            //     },
            //     data: v.monthDate
            //   },
            //   yAxis: {
            //     type: 'value',
            //     name: v.t('common.packageAmount'),
            //     minInterval: 1,
            //     boundaryGap: [ 0, 0.1 ]
            //   },
            //   series: [{ // 纵轴
            //     type: 'line',
            //     data: v.monthPackageNum
            //   }]
            // });
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
      // debugger;
    },
    addParam () {
      let v = this;
      if (v.dyParams.length > 4) {
        v.$Message.error('参数不能多于5个');
        return;
      }
      v.dyParams.push({
        parameterName: '',
        parameterType: '03', // 参数类型：01/Radio;02/Checkbox;03/input;04/Selection;05/Object;06/ReadOnly
        parameterKey: ''
      });
    },
    removeParam (index) {
      let v = this;
      if (v.dyParams.length === 1) {
        v.$Message.error('参数至少要一个');
        return;
      }
      v.dyParams.forEach((n, i) => {
        if (i === index) {
          v.dyParams.splice(i, 1);
        }
      });
    },
    getParams () {
      let v = this;
      let cid = '';
      if (v.companyInfo.systemCarrier && v.companyInfo.systemCarrier.systemCarrierId && v.companyInfo.systemCarrier.systemCarrierId !== '') {
        cid = v.companyInfo.systemCarrier.systemCarrierId;
      }
      v.axios.get(api.api_param + '?carrierId=' + cid)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              v.dyParams = data;
            } else {
              v.dyParams = [];
            }
            if (v.dyParams.length === 0) {
              if (v.companyInfo.status === '0' || v.companyInfo.status === '3') {
                v.dyParams.push({
                  parameterName: 'Token',
                  parameterType: '03', // 参数类型：01/Radio;02/Checkbox;03/input;04/Selection;05/Object;06/ReadOnly
                  parameterKey: 'token'
                });
              }
            }
            v.selectedParams = v.dyParams;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    this.getLogisInfo();
    // this.getYesterdayInfo();
  },
  mounted () {
    this.uploadFiles = this.$refs.uploadLogo.file;
    // this.drawLine();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/personalCenter.vue